import { Button, Drawer, Form, Row, Space } from 'antd';
import { StyledTable } from 'app/components/StyledTable/StyledTable';
import { FC } from 'react';
import TasksByRoute from '../TasksByRoute/TasksByRoute';
import { getRouteTableColumns } from './AddRouteToTaskDrawer.helpers';
import { useAddRouteToTaskDrawer } from './hooks/useAddRouteToTaskDrawer';

interface IProps {
  isOpen: boolean;

  onClose: () => void;
}

const AddRouteToTaskDrawer: FC<IProps> = ({ isOpen, onClose }) => {
  const {
    onCreateNewTask,
    selectedTaskId,
    t,
    isInitialDataLoaded,
    form,
    initialValues,
    groupedRoutesWithSelectedImplement,
    taskCategoryIds,
    onValuesChange,
    maxToDate,
    minFromDate,
    isAllRouteGroupsHaveSelectedImplement,
    setSelectedTaskId,
    onMoveRoutesToTask,
    routeTableItems,
  } = useAddRouteToTaskDrawer({
    isOpen,
  });

  return (
    <Drawer
      title={t('Task.ChooseTask', 'Choose task')}
      visible={isOpen}
      onClose={onClose}
      destroyOnClose
      placement="right"
      width={855}
      footer={
        <Row justify="end">
          <Space>
            <Button onClick={onClose}>{t('Common.Cancel', 'Cancel')}</Button>
            <Button
              disabled={!selectedTaskId}
              loading={false}
              onClick={onMoveRoutesToTask}
              type="primary"
            >
              {t('Task.Move', 'Move')}
            </Button>
          </Space>
        </Row>
      }
    >
      <Row style={{ marginBottom: 12 }}>
        {t('Task.MovableRoutes', 'Routes')}: {routeTableItems?.length || 0}
      </Row>

      {isInitialDataLoaded && (
        <Form
          layout="vertical"
          form={form}
          initialValues={initialValues}
          id="routesTableForm"
          onValuesChange={onValuesChange}
        >
          <StyledTable
            rowKey="id"
            dataSource={groupedRoutesWithSelectedImplement}
            columns={getRouteTableColumns()}
            pagination={false}
          />
        </Form>
      )}

      {isOpen && (
        <TasksByRoute
          onCreateNewTask={onCreateNewTask}
          startDate={minFromDate}
          endDate={maxToDate}
          taskCategoryIds={taskCategoryIds}
          isImplementSelected={isAllRouteGroupsHaveSelectedImplement}
          selectedTaskId={selectedTaskId}
          setSelectedTaskId={setSelectedTaskId}
        />
      )}
    </Drawer>
  );
};

export default AddRouteToTaskDrawer;
